import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { Form, EditListingActionButton, FieldRadioGroup } from '../../components';
import arrayMutators from 'final-form-arrays';

import css from './EditListingCancellationForm.css';

const EditListingCancellationFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        cancellationOptions,
        form,
        onBackWithoutSubmit,
      } = formRenderProps;

      const cancellationLabel = intl.formatMessage({
        id: 'EditListingCancellationForm.cancellationLabel',
      });

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessageUpdateListing = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingCancellationForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingCancellationForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessageUpdateListing}
          {errorMessageShowListing}

          <FieldRadioGroup
            className={css.features}
            id={'cancellation'}
            name={'cancellation'}
            label={cancellationLabel}
            options={cancellationOptions.map(item => ({
              key: item.key,
              label: intl.formatMessage({ id: item.labelId }),
              description: intl.formatMessage({ id: item.descriptionId }),
            }))}
          />
          <EditListingActionButton
            invalid={invalid}
            nextBtnMessage={saveActionMsg}
            nextBtnClassName={css.submitButton}
            form={form}
            onBackWithoutSubmit={onBackWithoutSubmit}
            submitInProgress={submitInProgress}
            submitReady={submitReady}
            submitDisabled={submitDisabled}
          />
        </Form>
      );
    }}
  />
);

EditListingCancellationFormComponent.defaultProps = { className: null, fetchErrors: null };

EditListingCancellationFormComponent.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  categories: arrayOf(
    shape({
      key: string.isRequired,
      labelId: string.isRequired,
    })
  ),
  subCategories: arrayOf(
    shape({
      key: string.isRequired,
      labelId: string.isRequired,
    })
  ),
};

export default compose(injectIntl)(EditListingCancellationFormComponent);
